import React, { useState } from 'react';
import useStyles from './styles';
import { Typography, Icon, Collapse } from '@mui/material';
import clsx from 'clsx';
import { Row, Column } from 'global/components/row';
import { useScreen } from 'global/styles';
import { get } from 'global/lib/lodash';

export default (props) => {
  const { panels } = props;
  const { isMobile } = useScreen();
  const classes = useStyles({ isMobile });
  const [state, setState] = useState({
    expanded: get(props, 'defaultPanel', get(panels, '0.id')),
  });

  return (
    <div className={classes.container}>
      <Column className={classes.accordion}>
        {panels.map((panel, i) => {
          const isOpen = state.expanded === panel.id;
          return (
            <Row key={i} fullWidth className={clsx('accordionRow', i !== panels.length - 1 ? 'notLast' : '')}>
              <Column fullWidth>
                <Row className="titlerow" fullWidth onClick={() => setState((s) => ({ ...s, expanded: s.expanded === panel.id ? '' : panel.id }))}>
                  <Typography className={classes.heading}>{panel.title}</Typography>
                  <Icon>{isOpen ? 'expand_less' : 'expand_more'}</Icon>
                </Row>
                <Collapse style={{ width: '100%' }} in={isOpen}>
                  {isOpen && panel.component({})}
                </Collapse>
              </Column>
            </Row>
          );
        })}
      </Column>
    </div>
  );
}